/**
 * Libellés français de la conformité réglementaire (CDC §6.4).
 *
 * Comme pour le parc machines, la traduction des codes de l'API vit en un seul
 * endroit : la fiche machine et l'écran de gestion des règles doivent dire la
 * même chose du même état.
 */
import type { ComplianceFormula, ComplianceOutcome, ComplianceUrgency } from '../api/client';

/**
 * PENDING est un simple horizon, DONE une échéance soldée : ni l'un ni l'autre
 * n'appelle d'action. DUE_SOON et OVERDUE, si.
 */
export const URGENCE_OBLIGATION: Record<ComplianceUrgency, { texte: string; classe: string }> = {
  PENDING: { texte: 'À venir', classe: 'suspendu' },
  DUE_SOON: { texte: 'Bientôt', classe: 'attente' },
  OVERDUE: { texte: 'En retard', classe: 'revoque' },
  DONE: { texte: 'Réalisée', classe: 'actif' },
};

export const RESULTAT_OBLIGATION: Record<ComplianceOutcome, string> = {
  OK: 'Conforme',
  RESERVES: 'Avec réserves',
  REFUSED: 'Refusé',
};

export const TYPE_FORMULE: Record<ComplianceFormula['kind'], string> = {
  FIXED_SCHEDULE: 'Échéance fixe',
  THRESHOLD_TABLE: 'Palier de seuil',
};
